var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.tileClasses,attrs:{"tag":"div","to":_vm.to,"event":_vm.disabled ? '' : 'click'}},[_c('div',{staticClass:"row justify-content-center"},[_c('img',{staticClass:"tile-icon",attrs:{"src":_vm.image}})]),_vm._v(" "),_c('div',{staticClass:"tile-title"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da13821","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuTile.vue
// module id = null
// module chunks = 